module.exports = __webpack_public_path__ + "img/sikringstiltak.058d3a01.jpg";